import ShUserAvatarUpload from '@/components/Helpers/ShUserAvatarUpload';
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import ShButton from '@/components/Helpers/ShButton';

import defaultAvatar from './default-avatar';

// @vue/component
export default {
  name: 'UserProfile',

  components: {
    ShUserAvatarUpload,
    ShUserAvatar,
    ShDividerLine,
    ShButton,
  },

  props: {
    shouldRefreshList: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      defaultAvatar,
      isCreatedForm: false,
      password: null,
      repeatedPassword: null,
      formHasError: false,
      errorMessage: null,
      userProfile: null,
      passwordTypeInput: 'password',
      passwordTypeInputRepeat: 'password',
    };
  },

  computed: {
    isLoggedUser() {
      const loggedUser = this.$store.getters['authorization/user'];
      return (this.user.users_uuid || this.user.user_uuid) === loggedUser.user_uuid;
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'users/add', 'users/update', 'users/getList', 'users/deleteAvatar',
        'users/create',
      ]);
    },
    userProfileList() {
      return this.$store.getters['userProfiles/list'];
    },
    getPasswordTypeInputIcon() {
      return this.passwordTypeInput === 'password' ? 'eye-slash' : 'eye';
    },
    getPasswordTypeInputIconRepeat() {
      return this.passwordTypeInputRepeat === 'password' ? 'eye-slash' : 'eye';
    },
  },

  created() {
    this.isCreatedForm = Object.keys(this.user).length === 0;
    this.userProfile = this.isCreatedForm ? { id: 1 } : {
      id: this.user.profile.id || this.user.profile.users_permissions_profiles_id_fk,
      name: this.user.profile.name || 'Profil Użytkownika',
    };
  },

  methods: {
    tooglePasswordTypeInput() {
      this.passwordTypeInput = this.passwordTypeInput === 'password' ? 'text' : 'password';
    },
    tooglePasswordTypeInputRepeat() {
      this.passwordTypeInputRepeat = this.passwordTypeInputRepeat === 'password' ? 'text' : 'password';
    },
    handleCancel() {
      this.__clearData();
      this.$emit('closeModal');
    },
    async handleUploadAvatar(avatar) {
      const params = {
        user_uuid: this.user.users_uuid || this.user.user_uuid,
        avatar,
      };

      await this.$store.dispatch('users/update', params);
      await this.$store.dispatch('authorization/checkIfUserSessionExists', { endpoint: 'authorization/checkIfUserSessionExist' });
      this.user.avatar = avatar;
      if (this.shouldRefreshList) await this.$store.dispatch('users/getList');
      this.$emit('closeModal');
      this.$notify.success({
        title: 'Zmiana danych',
        message: 'Nowe dane użytkownika zapisane poprawnie',
        customClass: 'callmeweb-notification',
      });
    },
    async handleDeleteAvatar() {
      const params = {
        user_uuid: this.user.users_uuid || this.user.user_uuid,
      };
      await this.$store.dispatch('users/deleteAvatar', params);
      await this.$store.dispatch('authorization/checkIfUserSessionExists', { endpoint: 'authorization/checkIfUserSessionExist' });
      if (this.shouldRefreshList) await this.$store.dispatch('users/getList');
      this.$emit('closeModal');
      this.$notify.success({
        title: 'Usunięcie avatara',
        message: 'Usunięto avatar użytkownika',
        customClass: 'callmeweb-notification',
      });
    },
    async handleSave() {
      if (this.isCreatedForm) {
        await this.createUser();
        return;
      }
      await this.editUser();
    },
    async editUser() {
      const params = {
        user_uuid: this.user.users_uuid || this.user.user_uuid,
        ...(this.password ? { password: this.password } : {}),
        name: this.user.name,
        last_name: this.user.last_name,
        email: this.user.email,
        users_permissions_profiles_id_fk: this.userProfile.id,
      };
      if (this.__validateForm()) {
        await this.$store.dispatch('users/update', params);
        await this.$store.dispatch('authorization/checkIfUserSessionExists', { endpoint: '/authorization/checkIfUserSessionExist' });
        if (this.shouldRefreshList) await this.$store.dispatch('users/getList');
        this.$EventBus.$emit('UPDATE_USER_PROFILE');
        this.$emit('closeModal');
        this.$notify.success({
          title: 'Zmiana danych',
          message: 'Nowe dane użytkownika zapisane poprawnie',
          customClass: 'callmeweb-notification',
        });
        this.__clearData();
      }
    },
    async createUser() {
      const params = {
        user_uuid: this.user.users_uuid || this.user.user_uuid,
        password: this.password,
        name: this.user.name,
        last_name: this.user.last_name,
        email: this.user.email,
        login: this.user.email,
        users_permissions_profiles_id_fk: this.userProfile.id,
      };
      if (this.__validateForm()) {
        const createUserResponse = await this.$store.dispatch('users/create', params);
        if (this.shouldRefreshList) await this.$store.dispatch('users/getList');
        if (createUserResponse) {
          this.$emit('closeModal');
          this.$notify.success({
            title: 'Nowy użytkownik',
            message: 'Utworzono nowego użytkownika',
            customClass: 'callmeweb-notification',
          });
          this.__clearData();
        } else {
          this.$notify.error({
            title: 'Nowy użytkownik',
            message: 'Podany adres e-mail jest już przypisany do konta',
            customClass: 'callmeweb-notification',
          });
        }
      }
    },
    __validateForm() {
      this.formHasError = false;
      // walidacja adresu email
      // eslint-disable-next-line no-useless-escape
      if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(this.user.email)) {
        this.formHasError = true;
        this.errorMessage = 'Nieprawidłowy adres email';
        return false;
      }

      if ((this.$store.getters['users/list'].filter(user => user.email === this.user.email).length > 0) && this.isCreatedForm) {
        this.formHasError = true;
        this.errorMessage = 'Użytkownik z takim adresem email już istnieje';
        return false;
      }

      if (!this.user.name) {
        this.formHasError = true;
        this.errorMessage = 'Imię jest wymanage';
        return false;
      }

      if (this.user.name.length < 3) {
        this.formHasError = true;
        this.errorMessage = 'Imię musi składać się z min. 3 znaków';
        return false;
      }

      if (!this.user.last_name) {
        this.formHasError = true;
        this.errorMessage = 'Nazwisko jest wymanage';
        return false;
      }

      if (this.user.last_name.length < 3) {
        this.formHasError = true;
        this.errorMessage = 'Nazwisko musi składać się z min. 3 znaków';
        return false;
      }

      // walidacja hasła
      if (this.isCreatedForm || this.password) {
        if (this.password !== this.repeatedPassword) {
          this.formHasError = true;
          this.errorMessage = 'Hasła nie są identyczne';
          return false;
        }

        if (!this.password) {
          this.formHasError = true;
          this.errorMessage = 'Hasło jest wymagane';
          return false;
        }

        if (this.password.length < 8) {
          this.formHasError = true;
          this.errorMessage = 'Hasło musi mieć długość min. 8 znaków';
          return false;
        }

        if (!(/[A-Z]/).test(this.password)) {
          this.formHasError = true;
          this.errorMessage = 'Hasła musi zawierać co najmniej jedną wielką literę';
          return false;
        }

        if (!(/\d/).test(this.password)) {
          this.formHasError = true;
          this.errorMessage = 'Hasło musi zawierać co najmniej jedną cyfrę';
          return false;
        }

        if (!this.userProfile.id) {
          this.formHasError = true;
          this.errorMessage = 'Profil uprawnień użytkownika jest wymagany';
          return false;
        }

        return true;
      }

      return true;
    },
    __clearData() {
      this.password = null;
      this.repeatedPassword = null;
      this.formHasError = false;
      this.errorMessage = null;
    },
  },
};
